export const RadioButtonDT = {
	radiobutton: {
		extend: {
			highlight: {
				color: 'var(--p-marketing-carrot)',
			},
		},
		css: ({ dt }) => `
          .p-radiobutton__marketing-highlight.p-radiobutton-checked .p-radiobutton-box {
              border-color: ${dt('radiobutton.highlight.color')};
              background: ${dt('radiobutton.highlight.color')};
          }
          .p-radiobutton__marketing-highlight.p-radiobutton-checked:not(.p-disabled):has(.p-radiobutton-input:hover) .p-radiobutton-box {
              border-color: ${dt('radiobutton.highlight.color')};
              background: ${dt('radiobutton.highlight.color')};
          }
        `,
	},
};
